import React from 'react';
import { useSelector } from 'react-redux';
import { Typography } from '@drone-js/core';
import { Stepper } from '@kite-js/core';
import { Location } from 'gql/autogen/Location';
import { LocationRef } from 'gql/autogen/LocationRef';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import LocationRefContainer from 'component/page/detail/Itineraries/HopOnHopOffItinerary/LocationRefStepper/LocationRefContainer';

interface OwnProps {
    pointsOfInterest?: LocationRef[];
    locations: Location[];
}

const RouteItemPoi: React.FC<OwnProps> = (props) => {
    const cms = useSelector(selectCmsFromBootstrap);

    if (!props.pointsOfInterest) {
        return null;
    }

    return (
        <>
            <Typography mx="4" variant="body-s" tag="span" data-testid="detail-itinerary-poi-title">
                {cms[134234]}
            </Typography>
            <Stepper
                activeStep={props.pointsOfInterest.length}
                fillProgress={true}
                variant="vertical"
                colors={{ label: { active: { color: 'primary', variant: 'solid' } } }}
                connector={{ type: 'dashed', width: 2, spacing: 0 }}
                data-testid="detail-itinerary-poi"
                py="M"
                px="L"
            >
                {props.pointsOfInterest.map((poi, index) => (
                    <LocationRefContainer key={index} locationRef={poi} locations={props.locations} />
                ))}
            </Stepper>
        </>
    );
};
RouteItemPoi.displayName = 'RouteItemPoi';

export default RouteItemPoi;
